import React, { useEffect, useState } from 'react';
import { SessionSummary } from '../SessionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

/**
 * Primary UI component for user interaction
 */
export var SessionList = function SessionList(_ref) {
  var schedules = _ref.schedules,
      cardShadow = _ref.cardShadow,
      onSelect = _ref.onSelect,
      classes = _ref.classes;
  var itemCount = schedules.length;

  var _useState = useState(3),
      maximumShown = _useState[0],
      setMaximumShown = _useState[1];

  var allShown = itemCount === maximumShown;

  var renderSessionSummaries = function renderSessionSummaries() {
    return schedules.slice(0, maximumShown).map(function (schedule, index) {
      return /*#__PURE__*/_jsx(SessionSummary, {
        schedule: schedule,
        onSelect: onSelect,
        shadow: cardShadow
      }, index);
    });
  };

  var increaseMaximumShown = function increaseMaximumShown(event) {
    event.preventDefault();

    if (maximumShown < itemCount) {
      var countDifference = itemCount - maximumShown;
      var additionalItems = countDifference >= 3 ? 3 : countDifference >= 0 ? countDifference : 0;
      setMaximumShown(maximumShown + additionalItems);
    }
  };

  useEffect(function () {
    setMaximumShown(itemCount >= 3 ? 3 : itemCount);
  }, [itemCount]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: schedules.length > 0 ? /*#__PURE__*/_jsx("div", {
      "data-cy": "SessionList",
      children: /*#__PURE__*/_jsxs("div", {
        className: classes,
        children: [/*#__PURE__*/_jsx("div", {
          className: "my-8",
          children: renderSessionSummaries()
        }), !allShown && /*#__PURE__*/_jsx("div", {
          className: "text-base text-center font-medium text-subkit-primary mb-6",
          children: /*#__PURE__*/_jsx("span", {
            className: "cursor-pointer",
            onClick: increaseMaximumShown,
            "data-cy": "SessionListViewMore",
            children: "View more sessions"
          })
        })]
      })
    }) : /*#__PURE__*/_jsx("div", {
      className: "flex items-center justify-center h-96",
      "data-cy": "SessionList",
      children: /*#__PURE__*/_jsx("div", {
        className: "mt-8",
        children: "No currently scheduled upcoming sessions."
      })
    })
  });
};
SessionList.defaultProps = {
  showTitle: true,
  cardShadow: false,
  classes: 'mx-auto w-full xl:w-11/12'
};